import { Sun, Cpu, Zap, Gauge, Router, BatteryCharging } from "lucide-react";

// Mirrors backend models.py ASSET_TYPES / WARRANTY_STATUSES.
export const ASSET_TYPES = [
  { key: "solar_panel", label: "Solar Panel", icon: Sun },
  { key: "optimizer", label: "Optimizer", icon: Cpu },
  { key: "inverter", label: "Inverter", icon: Zap },
  { key: "meter", label: "Meter", icon: Gauge },
  { key: "gateway", label: "Gateway", icon: Router },
  { key: "battery", label: "Battery", icon: BatteryCharging },
];
export const TYPE_MAP = Object.fromEntries(ASSET_TYPES.map((t) => [t.key, t]));

export const COLUMNS = [
  { key: "not_in_warranty", label: "Not in Warranty", accent: "#64748B", soft: "#F1F5F9" },
  { key: "in_warranty", label: "In Warranty", accent: "#15934F", soft: "#E8F6EE" },
  { key: "expiring_soon", label: "Expiring Soon", accent: "#B45309", soft: "#FEF3E2" },
  { key: "expired", label: "Expired Warranty", accent: "#C0392B", soft: "#FBEAE7" },
];
export const COL_MAP = Object.fromEntries(COLUMNS.map((c) => [c.key, c]));

export const daysLabel = (d) =>
  d == null ? "No warranty term" : d < 0 ? `Expired ${Math.abs(d)}d ago` : `${d}d remaining`;

// Mirrors backend WARRANTY_CLAIM_STATUSES.
export const CLAIM_STATUSES = [
  { k: "open", l: "Open", c: "#64748B" },
  { k: "submitted", l: "Submitted", c: "#2563EB" },
  { k: "approved", l: "Approved", c: "#15934F" },
  { k: "rejected", l: "Rejected", c: "#C0392B" },
  { k: "resolved", l: "Resolved", c: "#0E7490" },
];
export const CLAIM_MAP = Object.fromEntries(CLAIM_STATUSES.map((s) => [s.k, s]));
